module.exports = __webpack_public_path__ + "img/upper ruffle length.82e11e4d.png";